import React from "react";
import sell_graphic from "../../../assets/_home/sell_graphic.png";
import styles from "./Sell.module.scss";

const Sell = () => {
  return (
    <section className={styles.container}>
      <div className={styles.subContainer}>
        <div className={styles.leftContainer}>
          <img src={sell_graphic} alt="nfts" />
        </div>
        <div className={styles.rightContainer}>
          <div className={styles.textContainer}>
            <h1>
              Create and sell <br /> your NFTs
            </h1>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Facilisi
              ac phasellus placerat a pellentesque tellus sed egestas. Et
              tristique dictum sit tristique sed non. Lacinia lorem id
              consectetur pretium diam ut. Pellentesque eu sit blandit fringilla
              risus faucibus.
            </p>
            <button>Create</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Sell;
